// @flow

// Constants
import {
  FIELD,
} from 'fc-model-assets'

// Selectors
import makeAssetsOfCategory from './composers/makeAssetsOfCategory'

// Exports
export default makeAssetsOfCategory({
  category: FIELD,
})
